module.exports = __webpack_public_path__ + "d3a84e3135514c597bd83424c0d400a1.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/news/harpers-bazaar/harpers-bazaar-bride-2015-3.jpg
 ** module id = 464
 ** module chunks = 0
 **/